// API client — the request/retry/error/toCamel logic now lives in the shared
// cross-client package (@harvus/shared). This module just binds it to the web
// app's token source (MSAL via getAccessToken) and base URL ("/api"), and
// re-exports `api` and `toCamel` so existing imports keep working unchanged.
import { createApiClient, toCamel } from "@harvus/shared";
import { getAccessToken } from "../config/auth";

export const api = createApiClient({
  baseUrl: "/api",
  getToken: getAccessToken,
});

export { toCamel };
